var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container bg-white py-4 min-vh-100"},[_vm._m(0),(_vm.content.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.contentHtml)}}):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v("《安丘专技教育隐私协议》")])])
}]

export { render, staticRenderFns }